let items = document.querySelectorAll(".FAQ__header");
items = Array.prototype.slice.call(items, 0);
function toggleAccordion(){
    this.classList.toggle('active');
    this.parentElement.classList.toggle('FAQ__item--active')
    this.nextElementSibling.classList.toggle('active');
}

items.forEach(item => item.addEventListener('click', toggleAccordion));
